export const fake_value = (r7eApp, name, authorId, params = {}) => {
    console.log("Requesting fake_value", name, authorId, params);
    if (r7eApp.isUsingFakeData()) {
        const tb = fake_data[name];
        if (tb) {
            let data;
            
            // Try exact match first
            if (tb[authorId]) { 
                data = tb[authorId]; 
            } else {
                // Try with hyphens converted to underscores (common URL vs data key mismatch)
                const normalizedKey = authorId.replace(/-/g, '_');
                if (normalizedKey !== authorId && tb[normalizedKey]) {
                    data = tb[normalizedKey];
                } else {
                    // Try with underscores converted to hyphens
                    const hyphenKey = authorId.replace(/_/g, '-');
                    if (hyphenKey !== authorId && tb[hyphenKey]) {
                        data = tb[hyphenKey];
                    } else {
                        // Fall back to default
                        if (tb['_']) { 
                            data = tb['_']; 
                        }
                    }
                }
            }
            
            // Use params to avoid ESLint warning (currently not used but may be in future)
            if (Object.keys(params).length > 0) {
                // Future: could use params for filtering, pagination, etc.
                console.debug('Params received:', params);
            }
            
            return data;
        }
    }
    return null;
}

// Simple wildcard matching: '*' matches any sequence, '?' matches one char, case-insensitive
function wildcardMatch(str, pattern) {
    // Escape regex special chars except * and ?
    const rePattern = pattern
        .replace(/([.+^=!:${}()|[\]/\\])/g, '\\$1')
        .replace(/\*/g, '.*')
        .replace(/\?/g, '.');
    const re = new RegExp('^' + rePattern + '$', 'i');
    return re.test(str);
}

export const fake_search = (name) => {
    const tb = fake_data['authors'];
    let res = null;
    if (name === '*') {
        res = Object.keys(tb).map(key => ({
            authorId: key,
            name: tb[key].name,
            description: tb[key].description,
            avatar_url: tb[key].avatar_url,
        }));
    } else {
        // Use wildcard matching (case-insensitive) in key or author name
        const matchedKeys = Object.keys(tb).filter(key => {
            return wildcardMatch(key, name) ||
                (tb[key].name && wildcardMatch(tb[key].name, name));
        });
        if (matchedKeys.length > 0) {
            res = matchedKeys.map(key => ({
                authorId: key,
                name: tb[key].name,
                description: tb[key].description,
                avatar_url: tb[key].avatar_url,
            }));
        }
    }
    // console.log("res", res)
    return res;
}


export const fake_data = {
    authors: {
        bmeyer: { 
            name: "Bertrand Meyer",
            description: "Recognyzed author since July 2025",
            email: "bm@r7e.ai",
            email_verified: true,
            member_since: "2025-07-01",
            orcid: "0000-0002-5985-7434",
            gscholar: "W8nOgCwAAAAJ",
            homepage: "https://www.bertrandmeyer.com",
            avatar_url: "https://scholar.googleusercontent.com/citations?view_op=view_photo&user=W8nOgCwAAAAJ&citpid=2",
            tags: ["Software engineering", "Eiffel"],
            r_index: 12345,
            r_index_5: 123,
            rendering_count: 11111,
        },
        'victor-hugo': {
            name: "Victor Hugo",
            description: "French poet, novelist, and dramatist of the Romantic movement",
            avatar_url: null            
        },
        'ada-lovelace': {
            name: "Ada Lovelace",
            description: "English mathematician and writer, known for her work on the Analytical Engine",
            avatar_url: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Ada_Lovelace_portrait.jpg"
        },        
        _:{
            name: "Unknown",
            description: "Tester",
            email: "test@example.com",
            email_verified: true,
            member_since: "2025-01-01",
            homepage: "https://www.example.com",
            tags: ["Test", "Eiffel"],
            r_index: 111,
            r_index_5: 22,
            rendering_count: 121, 
        }
    },
    co_authors: {
        bmeyer: {
            items: [{
                name: "victor-hugo",
                description: "French poet, novelist, and dramatist of the Romantic movement"
            }
        ]
        },
        _: {
            items: []
        }
    },
    rendering_yearly: {
        bmeyer: {
            years: [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025],
            renderings: [910, 1050, 800, 750, 700, 650, 600, 400],
            total_renderings: 5860
        },
        _: {
            years: [2023, 2024, 2025],
            renderings: [50, 75, 25],
            total_renderings: 150
        }
    },
    bot_traffic: {
        bmeyer: {
            2018: [
                { bot: "Googlebot", count: 320, percentage: 35.2 },
                { bot: "Bingbot", count: 180, percentage: 19.8 },
                { bot: "ChatGPT-User", count: 150, percentage: 16.5 },
                { bot: "Claude-User", count: 120, percentage: 13.2 },
                { bot: "Perplexity-User", count: 80, percentage: 8.8 },
                { bot: "Other", count: 60, percentage: 6.6 }
            ],
            2019: [
                { bot: "Googlebot", count: 380, percentage: 36.2 },
                { bot: "Bingbot", count: 200, percentage: 19.0 },
                { bot: "ChatGPT-User", count: 180, percentage: 17.1 },
                { bot: "Claude-User", count: 140, percentage: 13.3 },
                { bot: "Perplexity-User", count: 100, percentage: 9.5 },
                { bot: "Other", count: 50, percentage: 4.8 }
            ],
            2020: [
                { bot: "Googlebot", count: 300, percentage: 37.5 },
                { bot: "Bingbot", count: 160, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 140, percentage: 17.5 },
                { bot: "Claude-User", count: 100, percentage: 12.5 },
                { bot: "Perplexity-User", count: 60, percentage: 7.5 },
                { bot: "Other", count: 40, percentage: 5.0 }
            ],
            2021: [
                { bot: "Googlebot", count: 280, percentage: 37.3 },
                { bot: "Bingbot", count: 150, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 130, percentage: 17.3 },
                { bot: "Claude-User", count: 90, percentage: 12.0 },
                { bot: "Perplexity-User", count: 50, percentage: 6.7 },
                { bot: "Other", count: 50, percentage: 6.7 }
            ],
            2022: [
                { bot: "Googlebot", count: 260, percentage: 37.1 },
                { bot: "Bingbot", count: 140, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 120, percentage: 17.1 },
                { bot: "Claude-User", count: 80, percentage: 11.4 },
                { bot: "Perplexity-User", count: 50, percentage: 7.1 },
                { bot: "Other", count: 50, percentage: 7.1 }
            ],
            2023: [
                { bot: "Googlebot", count: 240, percentage: 36.9 },
                { bot: "Bingbot", count: 130, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 110, percentage: 16.9 },
                { bot: "Claude-User", count: 70, percentage: 10.8 },
                { bot: "Perplexity-User", count: 50, percentage: 7.7 },
                { bot: "Other", count: 50, percentage: 7.7 }
            ],
            2024: [
                { bot: "Googlebot", count: 220, percentage: 36.7 },
                { bot: "Bingbot", count: 120, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 100, percentage: 16.7 },
                { bot: "Claude-User", count: 60, percentage: 10.0 },
                { bot: "Perplexity-User", count: 50, percentage: 8.3 },
                { bot: "Other", count: 50, percentage: 8.3 }
            ],
            2025: [
                { bot: "Googlebot", count: 150, percentage: 37.5 },
                { bot: "Bingbot", count: 80, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 70, percentage: 17.5 },
                { bot: "Claude-User", count: 40, percentage: 10.0 },
                { bot: "Perplexity-User", count: 30, percentage: 7.5 },
                { bot: "Other", count: 30, percentage: 7.5 }
            ]
        },
        _: {
            2025: [
                { bot: "Googlebot", count: 10, percentage: 40.0 },
                { bot: "Bingbot", count: 5, percentage: 20.0 },
                { bot: "ChatGPT-User", count: 5, percentage: 20.0 },
                { bot: "Other", count: 5, percentage: 20.0 }
            ]
        }
    },
    contents: {
        bmeyer: { 
            is_fake: true,
            total_count: 15,
            items: [
                {
                    "name": "More sizzle than steak? Using an LLM to produce verified bug fixes (new preprint)",
                    "contentId": "bmeyer-llm-verified-bug-fixes-2025",
                    "contentTitle": "More sizzle than steak? Using an LLM to produce verified bug fixes (new preprint)",
                    "rendering_count": 15420,
                    "signed_at": "2025-07-24",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/07/24/more-sizzle-than-steak-using-an-llm-to-produce-verified-bug-fixes/"
                },
                {
                    "name": "A paean to programming",
                    "contentId": "bmeyer-paean-to-programming-2025",
                    "contentTitle": "A paean to programming",
                    "rendering_count": 12340,
                    "signed_at": "2025-04-23",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/04/23/a-paean-to-programming/"
                },
                {
                    "name": "New article: obituary of Niklaus Wirth",
                    "contentId": "bmeyer-obituary-niklaus-wirth-2025",
                    "contentTitle": "New article: obituary of Niklaus Wirth",
                    "rendering_count": 9876,
                    "signed_at": "2025-03-04",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/03/04/new-article-obituary-of-niklaus-wirth/"
                },
                {
                    "name": "New preprint: Lessons from Formally Deployed Software Systems",
                    "contentId": "bmeyer-lessons-formally-deployed-2025",
                    "contentTitle": "New preprint: Lessons from Formally Deployed Software Systems",
                    "rendering_count": 8765,
                    "signed_at": "2025-03-04",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/03/04/new-preprint-lessons-from-formally-deployed-software-systems/"
                },
                {
                    "name": "New preprint: Seamless and Traceable Requirements",
                    "contentId": "bmeyer-seamless-traceable-requirements-2025",
                    "contentTitle": "New preprint: Seamless and Traceable Requirements",
                    "rendering_count": 7654,
                    "signed_at": "2025-03-03",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/03/03/new-preprint-seamless-and-traceable-requirements/"
                },
                {
                    "name": "New preprint: Loop unrolling — formal definition and application to testing",
                    "contentId": "bmeyer-loop-unrolling-formal-definition-2025",
                    "contentTitle": "New preprint: Loop unrolling — formal definition and application to testing",
                    "rendering_count": 6543,
                    "signed_at": "2025-03-04",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/02/28/new-preprint-loop-unrolling-formal-definition-and-application-to-testing/"
                },
                {
                    "name": "New preprint: a standard framework for research on bugs and automatic program repair",
                    "contentId": "bmeyer-standard-framework-bugs-automatic-repair-2025",
                    "contentTitle": "New preprint: a standard framework for research on bugs and automatic program repair",
                    "rendering_count": 5432,
                    "signed_at": "2025-02-27",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/02/27/new-preprint-a-standard-framework-for-research-on-bugs-and-automatic-program-repair/"
                },
                {
                    "name": "New paper: seeding contradiction",
                    "contentId": "bmeyer-seeding-contradiction-2025",
                    "contentTitle": "New paper: seeding contradiction",
                    "rendering_count": 4321,
                    "signed_at": "2025-02-26",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/02/26/new-paper-seeding-contradiction/"
                },
                {
                    "name": "New preprint: Programming Really Is Simple Mathematics",
                    "contentId": "bmeyer-programming-simple-mathematics-2025",
                    "contentTitle": "New preprint: Programming Really Is Simple Mathematics",
                    "rendering_count": 3210,
                    "signed_at": "2025-03-04",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/02/25/new-preprint-programming-really-is-simple-mathematics/"
                },
                {
                    "name": "This is much worse than Munich",
                    "contentId": "bmeyer-much-worse-than-munich-2025",
                    "contentTitle": "This is much worse than Munich",
                    "rendering_count": 2109,
                    "signed_at": "2025-02-21",
                    "publisher": "bmeyer",
                    "co_authors": [],
                    "url": "https://bertrandmeyer.com/2025/02/21/this-is-much-worse-than-munich/"
                },
   
                
            ]
        },
        _: { 
            is_fake: true,
            total_count: 1,
            items: [
                {
                    name: 'Nothing',
                    contentId: '000-000-000',
                    contentTitle: 'nothing.pdf',
                    rendering_count: 10,
                    publisher: "demo",
                    co_authors: []
                },             
            ]
        },        
    },
    global_traffic: {
        bmeyer: {
            data: [
                {
                    date: "2024-01-01",
                    "AI Agent": 3.2,
                    "AI Assistant": 1.8,
                    "AI Data Scraper": 5.1,
                    "AI Search Crawler": 2.3,
                    "Archiver": 1.2,
                    "Developer Helper": 0.7,
                    "Fetcher": 1.9,
                    "Headless Agent": 2.8,
                    "Intelligence Gatherer": 0.9,
                    "Scraper": 3.4,
                    "Search Engine Crawler": 8.2,
                    "Security Scanner": 1.1,
                    "SEO Crawler": 2.9,
                    "Uncategorized": 0.4,
                    "Undocumented AI Agent": 0.8
                },
                {
                    date: "2024-01-08",
                    "AI Agent": 3.8,
                    "AI Assistant": 2.1,
                    "AI Data Scraper": 4.8,
                    "AI Search Crawler": 2.6,
                    "Archiver": 1.4,
                    "Developer Helper": 0.9,
                    "Fetcher": 2.2,
                    "Headless Agent": 3.1,
                    "Intelligence Gatherer": 1.0,
                    "Scraper": 3.7,
                    "Search Engine Crawler": 7.9,
                    "Security Scanner": 1.3,
                    "SEO Crawler": 3.2,
                    "Uncategorized": 0.5,
                    "Undocumented AI Agent": 0.9
                },
                {
                    date: "2024-01-15",
                    "AI Agent": 4.1,
                    "AI Assistant": 2.4,
                    "AI Data Scraper": 5.3,
                    "AI Search Crawler": 2.8,
                    "Archiver": 1.6,
                    "Developer Helper": 1.1,
                    "Fetcher": 2.5,
                    "Headless Agent": 3.4,
                    "Intelligence Gatherer": 1.2,
                    "Scraper": 4.0,
                    "Search Engine Crawler": 8.5,
                    "Security Scanner": 1.5,
                    "SEO Crawler": 3.5,
                    "Uncategorized": 0.6,
                    "Undocumented AI Agent": 1.0
                },
                {
                    date: "2024-01-22",
                    "AI Agent": 3.9,
                    "AI Assistant": 2.2,
                    "AI Data Scraper": 5.0,
                    "AI Search Crawler": 2.5,
                    "Archiver": 1.3,
                    "Developer Helper": 0.8,
                    "Fetcher": 2.3,
                    "Headless Agent": 3.2,
                    "Intelligence Gatherer": 1.1,
                    "Scraper": 3.8,
                    "Search Engine Crawler": 8.1,
                    "Security Scanner": 1.4,
                    "SEO Crawler": 3.3,
                    "Uncategorized": 0.5,
                    "Undocumented AI Agent": 0.9
                },
                {
                    date: "2024-01-29",
                    "AI Agent": 4.3,
                    "AI Assistant": 2.6,
                    "AI Data Scraper": 5.5,
                    "AI Search Crawler": 3.0,
                    "Archiver": 1.8,
                    "Developer Helper": 1.3,
                    "Fetcher": 2.7,
                    "Headless Agent": 3.6,
                    "Intelligence Gatherer": 1.3,
                    "Scraper": 4.2,
                    "Search Engine Crawler": 8.7,
                    "Security Scanner": 1.7,
                    "SEO Crawler": 3.7,
                    "Uncategorized": 0.7,
                    "Undocumented AI Agent": 1.2
                },
                {
                    date: "2024-02-05",
                    "AI Agent": 4.0,
                    "AI Assistant": 2.3,
                    "AI Data Scraper": 5.2,
                    "AI Search Crawler": 2.7,
                    "Archiver": 1.5,
                    "Developer Helper": 1.0,
                    "Fetcher": 2.4,
                    "Headless Agent": 3.3,
                    "Intelligence Gatherer": 1.1,
                    "Scraper": 3.9,
                    "Search Engine Crawler": 8.3,
                    "Security Scanner": 1.5,
                    "SEO Crawler": 3.4,
                    "Uncategorized": 0.6,
                    "Undocumented AI Agent": 1.0
                },
                {
                    date: "2024-02-12",
                    "AI Agent": 4.5,
                    "AI Assistant": 2.8,
                    "AI Data Scraper": 5.8,
                    "AI Search Crawler": 3.2,
                    "Archiver": 2.0,
                    "Developer Helper": 1.5,
                    "Fetcher": 2.9,
                    "Headless Agent": 3.8,
                    "Intelligence Gatherer": 1.4,
                    "Scraper": 4.4,
                    "Search Engine Crawler": 9.0,
                    "Security Scanner": 1.8,
                    "SEO Crawler": 3.9,
                    "Uncategorized": 0.8,
                    "Undocumented AI Agent": 1.3
                }
            ],
            date_range: {
                earliest: "2024-01-01",
                latest: "2024-12-31"
            }
        },
        _: {
            data: [
                {
                    date: "2024-01-01",
                    "AI Agent": 2.0,
                    "AI Assistant": 1.0,
                    "AI Data Scraper": 3.0,
                    "Search Engine Crawler": 5.0,
                    "Other": 2.0
                },
                {
                    date: "2024-01-08",
                    "AI Agent": 2.2,
                    "AI Assistant": 1.2,
                    "AI Data Scraper": 3.2,
                    "Search Engine Crawler": 5.2,
                    "Other": 2.2
                }
            ],
            date_range: {
                earliest: "2024-01-01",
                latest: "2024-01-31"
            }
        }
    },
    traffic_date_ranges: {
        bmeyer: {
            available_ranges: [
                {
                    label: "Last 30 days",
                    start_date: "2024-01-01",
                    end_date: "2024-01-31"
                },
                {
                    label: "Last 3 months",
                    start_date: "2023-11-01",
                    end_date: "2024-01-31"
                },
                {
                    label: "Last 6 months",
                    start_date: "2023-08-01",
                    end_date: "2024-01-31"
                },
                {
                    label: "Last year",
                    start_date: "2023-01-01",
                    end_date: "2024-01-31"
                }
            ],
            default_range: {
                start_date: "2024-01-01",
                end_date: "2024-01-31"
            }
        },
        _: {
            available_ranges: [
                {
                    label: "Last 30 days",
                    start_date: "2024-01-01",
                    end_date: "2024-01-31"
                }
            ],
            default_range: {
                start_date: "2024-01-01",
                end_date: "2024-01-31"
            }
        }
    },
    traffic_overview: {
        bmeyer: {
            total_visits: 45789,
            total_page_views: 123456,
            unique_agents: 247,
            bot_percentage: 78.5,
            peak_day: "2024-01-15",
            peak_visits: 2347,
            growth_rate: 12.3,
            time_patterns: {
                hourly_distribution: [
                    { hour: 0, visits: 1200 },
                    { hour: 1, visits: 900 },
                    { hour: 2, visits: 700 },
                    { hour: 3, visits: 600 },
                    { hour: 4, visits: 800 },
                    { hour: 5, visits: 1100 },
                    { hour: 6, visits: 1500 },
                    { hour: 7, visits: 2200 },
                    { hour: 8, visits: 2800 },
                    { hour: 9, visits: 3200 },
                    { hour: 10, visits: 3500 },
                    { hour: 11, visits: 3800 },
                    { hour: 12, visits: 3600 },
                    { hour: 13, visits: 3400 },
                    { hour: 14, visits: 3700 },
                    { hour: 15, visits: 3900 },
                    { hour: 16, visits: 3500 },
                    { hour: 17, visits: 3200 },
                    { hour: 18, visits: 2800 },
                    { hour: 19, visits: 2400 },
                    { hour: 20, visits: 2000 },
                    { hour: 21, visits: 1700 },
                    { hour: 22, visits: 1400 },
                    { hour: 23, visits: 1300 }
                ]
            },
            key_metrics: {
                avg_session_duration: 234, // seconds
                bounce_rate: 23.4, // percentage
                pages_per_session: 2.8
            }
        },
        _: {
            total_visits: 1234,
            total_page_views: 2345,
            unique_agents: 12,
            bot_percentage: 45.2,
            peak_day: "2024-01-10",
            peak_visits: 67,
            growth_rate: 5.7,
            time_patterns: {
                hourly_distribution: [
                    { hour: 9, visits: 50 },
                    { hour: 10, visits: 75 },
                    { hour: 11, visits: 100 },
                    { hour: 14, visits: 120 },
                    { hour: 15, visits: 90 }
                ]
            },
            key_metrics: {
                avg_session_duration: 180,
                bounce_rate: 35.0,
                pages_per_session: 1.8
            }
        }
    },
    agent_types: {
        bmeyer: {
            categories: [
                {
                    name: "Human Traffic",
                    count: 8500,
                    percentage: 15.5,
                    contribution: "Direct engagement",
                    agents: [
                        { name: "Direct Visits", count: 4250, percentage: 7.8 },
                        { name: "Organic Search", count: 2550, percentage: 4.7 },
                        { name: "Social Media", count: 1020, percentage: 1.9 },
                        { name: "Referral Links", count: 680, percentage: 1.1 }
                    ]
                },
                {
                    name: "Traditional Bots",
                    count: 27500,
                    percentage: 50.2,
                    contribution: "Indirect or None",
                    agents: [
                        { name: "Googlebot", count: 11000, percentage: 20.1 },
                        { name: "Bingbot", count: 4120, percentage: 7.5 },
                        { name: "Slurp", count: 2560, percentage: 4.7 },
                        { name: "DuckDuckBot", count: 1334, percentage: 2.4 },
                        { name: "facebookexternalhit", count: 2814, percentage: 5.1 },
                        { name: "Twitterbot", count: 1880, percentage: 3.4 },
                        { name: "LinkedInBot", count: 1318, percentage: 2.4 },
                        { name: "Nmap", count: 947, percentage: 1.7 },
                        { name: "Qualys", count: 680, percentage: 1.2 },
                        { name: "SemrushBot", count: 2014, percentage: 3.7 },
                        { name: "Unknown", count: 1068, percentage: 1.9 },
                        { name: "Custom Crawler", count: 761, percentage: 1.4 }
                    ]
                },
                {
                    name: "AI Access Agents",
                    count: 12890,
                    percentage: 23.5,
                    contribution: "Assistive / RAG",
                    agents: [
                        { name: "ChatGPT-User", count: 4567, percentage: 8.3 },
                        { name: "Claude-User", count: 3234, percentage: 5.9 },
                        { name: "Perplexity-User", count: 2789, percentage: 5.1 },
                        { name: "Gemini-User", count: 2300, percentage: 4.2 }
                    ]
                },
                {
                    name: "AI Data Scrapers",
                    count: 5967,
                    percentage: 10.8,
                    contribution: "Direct",
                    agents: [
                        { name: "Common Crawl", count: 2074, percentage: 3.8 },
                        { name: "Archive.org", count: 1340, percentage: 2.4 },
                        { name: "AI Data Scraper", count: 1007, percentage: 1.8 },
                        { name: "Headless Agent", count: 779, percentage: 1.4 },
                        { name: "Training Bot", count: 767, percentage: 1.4 }
                    ]
                }
            ],
            trends: [
                { date: "2024-01-01", "Human Traffic": 1200, "Traditional Bots": 3200, "AI Access Agents": 1800, "AI Data Scrapers": 800 },
                { date: "2024-01-08", "Human Traffic": 1350, "Traditional Bots": 3400, "AI Access Agents": 1900, "AI Data Scrapers": 900 },
                { date: "2024-01-15", "Human Traffic": 1100, "Traditional Bots": 3600, "AI Access Agents": 2100, "AI Data Scrapers": 850 },
                { date: "2024-01-22", "Human Traffic": 1400, "Traditional Bots": 3300, "AI Access Agents": 2000, "AI Data Scrapers": 1000 },
                { date: "2024-01-29", "Human Traffic": 1250, "Traditional Bots": 3700, "AI Access Agents": 2200, "AI Data Scrapers": 950 }
            ]
        },
        _: {
            categories: [
                {
                    name: "Human Traffic",
                    count: 185,
                    percentage: 15.0,
                    contribution: "Direct engagement",
                    agents: [
                        { name: "Direct Visits", count: 92, percentage: 7.5 },
                        { name: "Organic Search", count: 55, percentage: 4.5 },
                        { name: "Social Media", count: 22, percentage: 1.8 },
                        { name: "Referral Links", count: 16, percentage: 1.2 }
                    ]
                },
                {
                    name: "Traditional Bots",
                    count: 567,
                    percentage: 45.9,
                    contribution: "Indirect or None",
                    agents: [
                        { name: "Googlebot", count: 345, percentage: 28.0 },
                        { name: "Bingbot", count: 222, percentage: 18.0 }
                    ]
                },
                {
                    name: "AI Access Agents",
                    count: 345,
                    percentage: 28.0,
                    contribution: "Assistive / RAG",
                    agents: [
                        { name: "ChatGPT-User", count: 200, percentage: 16.2 },
                        { name: "Claude-User", count: 145, percentage: 11.7 }
                    ]
                },
                {
                    name: "AI Data Scrapers",
                    count: 137,
                    percentage: 11.1,
                    contribution: "Direct",
                    agents: [
                        { name: "Common Crawl", count: 85, percentage: 6.9 },
                        { name: "AI Data Scraper", count: 52, percentage: 4.2 }
                    ]
                }
            ],
            trends: [
                { date: "2024-01-01", "Human Traffic": 25, "Traditional Bots": 50, "AI Access Agents": 30, "AI Data Scrapers": 15 },
                { date: "2024-01-08", "Human Traffic": 30, "Traditional Bots": 55, "AI Access Agents": 35, "AI Data Scrapers": 20 }
            ]
        }
    },
    llm_referrals: {
        bmeyer: {
            platforms: [
                {
                    name: "ChatGPT",
                    referrals: 12450,
                    traffic_generated: 8900,
                    percentage: 35.2,
                    conversion_rate: 71.5,
                    avg_engagement: 245
                },
                {
                    name: "Claude",
                    referrals: 8760,
                    traffic_generated: 6230,
                    percentage: 24.8,
                    conversion_rate: 71.1,
                    avg_engagement: 312
                },
                {
                    name: "Perplexity",
                    referrals: 6540,
                    traffic_generated: 4890,
                    percentage: 18.5,
                    conversion_rate: 74.8,
                    avg_engagement: 198
                },
                {
                    name: "Gemini",
                    referrals: 4320,
                    traffic_generated: 2980,
                    percentage: 12.2,
                    conversion_rate: 69.0,
                    avg_engagement: 267
                },
                {
                    name: "Copilot",
                    referrals: 2340,
                    traffic_generated: 1670,
                    percentage: 6.6,
                    conversion_rate: 71.4,
                    avg_engagement: 189
                },
                {
                    name: "Bard",
                    referrals: 890,
                    traffic_generated: 620,
                    percentage: 2.7,
                    conversion_rate: 69.7,
                    avg_engagement: 156
                }
            ],
            citation_metrics: {
                total_citations: 34200,
                accuracy_rate: 87.3,
                attributed_traffic: 25490,
                avg_citation_depth: 2.4
            },
            content_by_platform: {
                "ChatGPT": [
                    {
                        content_id: "bmeyer-llm-verified-bug-fixes-2025",
                        title: "More sizzle than steak? Using an LLM to produce verified bug fixes",
                        url: "https://example.com/bmeyer-llm-verified-bug-fixes-2025",
                        referrals: 3450,
                        traffic_generated: 2480,
                        citation_context: "This paper demonstrates innovative approaches to automated bug fixing using LLMs with formal verification...",
                        context_type: "Technical Discussion",
                        impact_score: 92
                    },
                    {
                        content_id: "bmeyer-paean-programming-2025",
                        title: "A paean to programming",
                        url: "https://example.com/bmeyer-paean-programming-2025",
                        referrals: 2890,
                        traffic_generated: 2070,
                        citation_context: "A philosophical exploration of programming as an art form and intellectual discipline...",
                        context_type: "Philosophical",
                        impact_score: 88
                    },
                    {
                        content_id: "bmeyer-wirth-obituary-2025",
                        title: "New article: obituary of Niklaus Wirth",
                        url: "https://example.com/bmeyer-wirth-obituary-2025",
                        referrals: 2340,
                        traffic_generated: 1680,
                        citation_context: "A tribute to the pioneering computer scientist and creator of Pascal...",
                        context_type: "Biographical",
                        impact_score: 85
                    }
                ],
                "Claude": [
                    {
                        content_id: "bmeyer-llm-verified-bug-fixes-2025",
                        title: "More sizzle than steak? Using an LLM to produce verified bug fixes",
                        url: "https://example.com/bmeyer-llm-verified-bug-fixes-2025",
                        referrals: 2450,
                        traffic_generated: 1780,
                        citation_context: "This research presents a novel methodology for combining LLMs with formal verification techniques...",
                        context_type: "Technical Discussion",
                        impact_score: 94
                    },
                    {
                        content_id: "bmeyer-formal-systems-2025",
                        title: "New preprint: Lessons from Formally Deployed Software Systems",
                        url: "https://example.com/bmeyer-formal-systems-2025",
                        referrals: 1980,
                        traffic_generated: 1420,
                        citation_context: "Analysis of real-world software systems that have been formally verified...",
                        context_type: "Case Study",
                        impact_score: 89
                    }
                ],
                "Perplexity": [
                    {
                        content_id: "bmeyer-llm-verified-bug-fixes-2025",
                        title: "More sizzle than steak? Using an LLM to produce verified bug fixes",
                        url: "https://example.com/bmeyer-llm-verified-bug-fixes-2025",
                        referrals: 1890,
                        traffic_generated: 1420,
                        citation_context: "Recent advances in automated software verification using large language models...",
                        context_type: "Research Summary",
                        impact_score: 87
                    }
                ]
            },
            trends: [
                { date: "2024-01-01", "ChatGPT": 1200, "Claude": 800, "Perplexity": 600, "Gemini": 400, "Copilot": 200, "Bard": 100 },
                { date: "2024-01-08", "ChatGPT": 1350, "Claude": 900, "Perplexity": 650, "Gemini": 450, "Copilot": 220, "Bard": 110 },
                { date: "2024-01-15", "ChatGPT": 1100, "Claude": 750, "Perplexity": 700, "Gemini": 500, "Copilot": 250, "Bard": 120 },
                { date: "2024-01-22", "ChatGPT": 1400, "Claude": 950, "Perplexity": 750, "Gemini": 550, "Copilot": 280, "Bard": 130 },
                { date: "2024-01-29", "ChatGPT": 1250, "Claude": 850, "Perplexity": 800, "Gemini": 600, "Copilot": 300, "Bard": 140 }
            ],
            attribution: {
                direct_referrals: 25490,
                direct_percentage: 74.5,
                indirect_citations: 5670,
                indirect_percentage: 16.6,
                seo_boost: 2340,
                seo_percentage: 6.8,
                social_mentions: 700,
                social_percentage: 2.1
            },
            behavior_patterns: {
                // User Journey Analysis
                avg_session_duration: 312,
                bounce_rate: 28.7,
                pages_per_session: 3.2,
                
                // Content Engagement Patterns
                deep_reading_rate: 52.3,
                quick_scan_rate: 34.1,
                social_sharing_rate: 13.6,
                
                // Time-based Patterns
                peak_hours: "9AM-3PM",
                peak_days: "Mon-Fri",
                avg_time_on_page: 245,
                
                // Return Visitor Analysis
                return_visitor_rate: 35.2,
                avg_visits_per_user: 2.1,
                avg_days_between_visits: 8.7
            }
        },
        _: {
            platforms: [
                {
                    name: "ChatGPT",
                    referrals: 450,
                    traffic_generated: 320,
                    percentage: 36.5,
                    conversion_rate: 71.1,
                    avg_engagement: 180
                },
                {
                    name: "Claude",
                    referrals: 320,
                    traffic_generated: 230,
                    percentage: 26.0,
                    conversion_rate: 71.9,
                    avg_engagement: 195
                },
                {
                    name: "Perplexity",
                    referrals: 150,
                    traffic_generated: 110,
                    percentage: 12.2,
                    conversion_rate: 73.3,
                    avg_engagement: 165
                }
            ],
            citation_metrics: {
                total_citations: 920,
                accuracy_rate: 82.1,
                attributed_traffic: 660,
                avg_citation_depth: 1.8
            },
            content_by_platform: {
                "ChatGPT": [
                    {
                        content_id: "test-content-1",
                        title: "Test Content Title",
                        url: "https://example.com/test-content-1",
                        referrals: 200,
                        traffic_generated: 140,
                        citation_context: "This content demonstrates key concepts in software engineering...",
                        context_type: "Educational",
                        impact_score: 75
                    }
                ]
            },
            trends: [
                { date: "2024-01-01", "ChatGPT": 45, "Claude": 32, "Perplexity": 15 },
                { date: "2024-01-08", "ChatGPT": 50, "Claude": 35, "Perplexity": 18 }
            ],
            attribution: {
                direct_referrals: 660,
                direct_percentage: 71.7,
                indirect_citations: 180,
                indirect_percentage: 19.6,
                seo_boost: 60,
                seo_percentage: 6.5,
                social_mentions: 20,
                social_percentage: 2.2
            },
            behavior_patterns: {
                // User Journey Analysis
                avg_session_duration: 245,
                bounce_rate: 32.5,
                pages_per_session: 2.8,
                
                // Content Engagement Patterns
                deep_reading_rate: 45.2,
                quick_scan_rate: 38.7,
                social_sharing_rate: 16.1,
                
                // Time-based Patterns
                peak_hours: "10AM-2PM",
                peak_days: "Tue-Thu",
                avg_time_on_page: 187,
                
                // Return Visitor Analysis
                return_visitor_rate: 28.4,
                avg_visits_per_user: 1.8,
                avg_days_between_visits: 12.5
            }
        }
    },
    geographic_data: {
        bmeyer: {
            countries: [
                { country: "United States", country_code: "US", count: 12456, percentage: 27.2, city_breakdown: [
                    { city: "San Francisco", count: 3456, percentage: 7.5 },
                    { city: "New York", count: 2890, percentage: 6.3 },
                    { city: "Seattle", count: 2234, percentage: 4.9 },
                    { city: "Austin", count: 1876, percentage: 4.1 },
                    { city: "Other", count: 2000, percentage: 4.4 }
                ]},
                { country: "Germany", country_code: "DE", count: 5678, percentage: 12.4, city_breakdown: [
                    { city: "Berlin", count: 2345, percentage: 5.1 },
                    { city: "Munich", count: 1567, percentage: 3.4 },
                    { city: "Hamburg", count: 1234, percentage: 2.7 },
                    { city: "Other", count: 532, percentage: 1.2 }
                ]},
                { country: "United Kingdom", country_code: "GB", count: 4321, percentage: 9.4, city_breakdown: [
                    { city: "London", count: 2890, percentage: 6.3 },
                    { city: "Manchester", count: 867, percentage: 1.9 },
                    { city: "Edinburgh", count: 564, percentage: 1.2 }
                ]},
                { country: "France", country_code: "FR", count: 3456, percentage: 7.5, city_breakdown: [
                    { city: "Paris", count: 2100, percentage: 4.6 },
                    { city: "Lyon", count: 789, percentage: 1.7 },
                    { city: "Marseille", count: 567, percentage: 1.2 }
                ]},
                { country: "Japan", country_code: "JP", count: 2890, percentage: 6.3, city_breakdown: [
                    { city: "Tokyo", count: 1789, percentage: 3.9 },
                    { city: "Osaka", count: 678, percentage: 1.5 },
                    { city: "Kyoto", count: 423, percentage: 0.9 }
                ]},
                { country: "Canada", country_code: "CA", count: 2345, percentage: 5.1, city_breakdown: [
                    { city: "Toronto", count: 1234, percentage: 2.7 },
                    { city: "Vancouver", count: 678, percentage: 1.5 },
                    { city: "Montreal", count: 433, percentage: 0.9 }
                ]},
                { country: "Netherlands", country_code: "NL", count: 1987, percentage: 4.3, city_breakdown: [
                    { city: "Amsterdam", count: 1234, percentage: 2.7 },
                    { city: "Rotterdam", count: 453, percentage: 1.0 },
                    { city: "The Hague", count: 300, percentage: 0.7 }
                ]},
                { country: "Australia", country_code: "AU", count: 1654, percentage: 3.6, city_breakdown: [
                    { city: "Sydney", count: 789, percentage: 1.7 },
                    { city: "Melbourne", count: 567, percentage: 1.2 },
                    { city: "Brisbane", count: 298, percentage: 0.7 }
                ]},
                { country: "Switzerland", country_code: "CH", count: 1456, percentage: 3.2, city_breakdown: [
                    { city: "Zurich", count: 678, percentage: 1.5 },
                    { city: "Geneva", count: 456, percentage: 1.0 },
                    { city: "Basel", count: 322, percentage: 0.7 }
                ]},
                { country: "Sweden", country_code: "SE", count: 1234, percentage: 2.7, city_breakdown: [
                    { city: "Stockholm", count: 789, percentage: 1.7 },
                    { city: "Gothenburg", count: 345, percentage: 0.8 },
                    { city: "Malmö", count: 100, percentage: 0.2 }
                ]}
            ],
            continent_summary: [
                { continent: "North America", count: 14801, percentage: 32.3 },
                { continent: "Europe", count: 19127, percentage: 41.8 },
                { continent: "Asia", count: 8234, percentage: 18.0 },
                { continent: "Oceania", count: 1854, percentage: 4.1 },
                { continent: "South America", count: 1234, percentage: 2.7 },
                { continent: "Africa", count: 539, percentage: 1.2 }
            ],
            time_zone_distribution: [
                { timezone: "UTC-8", count: 5678, percentage: 12.4, label: "Pacific Time" },
                { timezone: "UTC-5", count: 4321, percentage: 9.4, label: "Eastern Time" },
                { timezone: "UTC+1", count: 8901, percentage: 19.4, label: "Central European Time" },
                { timezone: "UTC+0", count: 4567, percentage: 10.0, label: "Greenwich Mean Time" },
                { timezone: "UTC+9", count: 2890, percentage: 6.3, label: "Japan Standard Time" }
            ]
        },
        _: {
            countries: [
                { country: "United States", country_code: "US", count: 567, percentage: 45.9, city_breakdown: [
                    { city: "New York", count: 234, percentage: 19.0 },
                    { city: "Los Angeles", count: 189, percentage: 15.3 },
                    { city: "Other", count: 144, percentage: 11.7 }
                ]},
                { country: "Germany", country_code: "DE", count: 234, percentage: 19.0, city_breakdown: [
                    { city: "Berlin", count: 123, percentage: 10.0 },
                    { city: "Munich", count: 111, percentage: 9.0 }
                ]},
                { country: "United Kingdom", country_code: "GB", count: 189, percentage: 15.3, city_breakdown: [
                    { city: "London", count: 145, percentage: 11.7 },
                    { city: "Other", count: 44, percentage: 3.6 }
                ]},
                { country: "Other", country_code: "XX", count: 244, percentage: 19.8, city_breakdown: [] }
            ],
            continent_summary: [
                { continent: "North America", count: 567, percentage: 45.9 },
                { continent: "Europe", count: 423, percentage: 34.3 },
                { continent: "Asia", count: 134, percentage: 10.9 },
                { continent: "Other", count: 110, percentage: 8.9 }
            ],
            time_zone_distribution: [
                { timezone: "UTC-5", count: 234, percentage: 19.0, label: "Eastern Time" },
                { timezone: "UTC+1", count: 189, percentage: 15.3, label: "Central European Time" },
                { timezone: "UTC+0", count: 156, percentage: 12.6, label: "Greenwich Mean Time" }
            ]
        }
    },
    content_info: {
        "bmeyer_bmeyer-llm-verified-bug-fixes-2025": {
            contentId: "bmeyer-llm-verified-bug-fixes-2025",
            title: "More sizzle than steak? Using an LLM to produce verified bug fixes (new preprint)",
            name: "More sizzle than steak? Using an LLM to produce verified bug fixes (new preprint)",
            publisher: "bmeyer",
            signed_at: "2025-07-24",
            rendering_count: 15420
        },
        "bmeyer_bmeyer-paean-to-programming-2025": {
            contentId: "bmeyer-paean-to-programming-2025", 
            title: "A paean to programming",
            name: "A paean to programming",
            publisher: "bmeyer",
            signed_at: "2025-04-23",
            rendering_count: 12340
        },
        "bmeyer_bmeyer-obituary-niklaus-wirth-2025": {
            contentId: "bmeyer-obituary-niklaus-wirth-2025", 
            title: "New article: obituary of Niklaus Wirth",
            name: "New article: obituary of Niklaus Wirth",
            publisher: "bmeyer",
            signed_at: "2025-03-04",
            rendering_count: 9876
        },
        _: {
            contentId: "sample-content",
            name: "Sample Content Title", 
            publisher: "Example Publisher",
            signed_at: "2025-01-01",
            rendering_count: 1234
        }
    },
    content_traffic_overview: {
        "bmeyer_bmeyer-llm-verified-bug-fixes-2025": {
            total_traffic: 15420,
            human_traffic: 4862,
            ai_access_traffic: 6741,
            ai_scrapers_traffic: 2853,
            traditional_bots_traffic: 964,
            traffic_growth: 18.5,
            trends: {
                dates: ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05", "2024-01-06", "2024-01-07"],
                human: [850, 920, 780, 1050, 1200, 890, 950],
                ai_access: [1200, 1340, 1180, 1480, 1650, 1290, 1380],
                ai_scrapers: [520, 580, 480, 620, 720, 540, 590],
                traditional_bots: [180, 200, 160, 210, 240, 180, 190]
            },
            peak_metrics: {
                peak_day: "2024-01-05",
                peak_traffic: 3810,
                peak_ai_ratio: 72.4
            }
        },
        "bmeyer_bmeyer-paean-to-programming-2025": {
            total_traffic: 12340,
            human_traffic: 3702,
            ai_access_traffic: 5406,
            ai_scrapers_traffic: 2284,
            traditional_bots_traffic: 948,
            traffic_growth: 15.2,
            trends: {
                dates: ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05", "2024-01-06", "2024-01-07"],
                human: [680, 740, 620, 840, 960, 712, 760],
                ai_access: [960, 1072, 944, 1184, 1320, 1032, 1104],
                ai_scrapers: [416, 464, 384, 496, 576, 432, 472],
                traditional_bots: [144, 160, 128, 168, 192, 144, 152]
            },
            peak_metrics: {
                peak_day: "2024-01-05",
                peak_traffic: 3048,
                peak_ai_ratio: 70.8
            }
        },
        _: {
            total_traffic: 8750,
            human_traffic: 2625,
            ai_access_traffic: 3850,
            ai_scrapers_traffic: 1575,
            traditional_bots_traffic: 700,
            traffic_growth: 12.3,
            trends: {
                dates: ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05", "2024-01-06", "2024-01-07"],
                human: [420, 480, 380, 520, 580, 440, 480],
                ai_access: [620, 680, 580, 720, 800, 620, 680],
                ai_scrapers: [280, 320, 240, 360, 400, 300, 320],
                traditional_bots: [120, 140, 100, 160, 180, 140, 150]
            },
            peak_metrics: {
                peak_day: "2024-01-05",
                peak_traffic: 1960,
                peak_ai_ratio: 68.2
            }
        }
    },
    content_agent_types: {
        "bmeyer_bmeyer-llm-verified-bug-fixes-2025": {
            categories: [
                {
                    name: "AI Access Agents",
                    count: 6741,
                    percentage: 43.7,
                    agents: [
                        { name: "ChatGPT", count: 2856, percentage: 42.4, category: "AI Access Agents" },
                        { name: "Claude", count: 1823, percentage: 27.0, category: "AI Access Agents" },
                        { name: "Perplexity", count: 1346, percentage: 20.0, category: "AI Access Agents" },
                        { name: "Gemini", count: 716, percentage: 10.6, category: "AI Access Agents" }
                    ]
                },
                {
                    name: "Human Traffic",
                    count: 4862,
                    percentage: 31.5,
                    agents: [
                        { name: "Direct Visits", count: 2431, percentage: 50.0, category: "Human Traffic" },
                        { name: "Social Media", count: 1459, percentage: 30.0, category: "Human Traffic" },
                        { name: "Email Links", count: 972, percentage: 20.0, category: "Human Traffic" }
                    ]
                },
                {
                    name: "AI Data Scrapers",
                    count: 2853,
                    percentage: 18.5,
                    agents: [
                        { name: "GPTBot", count: 1141, percentage: 40.0, category: "AI Data Scrapers" },
                        { name: "Claude-Web", count: 856, percentage: 30.0, category: "AI Data Scrapers" },
                        { name: "Anthropic-AI", count: 571, percentage: 20.0, category: "AI Data Scrapers" },
                        { name: "OpenAI-Crawler", count: 285, percentage: 10.0, category: "AI Data Scrapers" }
                    ]
                },
                {
                    name: "Traditional Bots",
                    count: 964,
                    percentage: 6.3,
                    agents: [
                        { name: "Googlebot", count: 482, percentage: 50.0, category: "Traditional Bots" },
                        { name: "Bingbot", count: 193, percentage: 20.0, category: "Traditional Bots" },
                        { name: "Facebookexternalhit", count: 96, percentage: 10.0, category: "Traditional Bots" },
                        { name: "Other crawlers", count: 193, percentage: 20.0, category: "Traditional Bots" }
                    ]
                }
            ],
            total_ai_agents: 9594,
            human_percentage: 31.5,
            ai_percentage: 68.5
        },
        _: {
            categories: [
                {
                    name: "AI Access Agents",
                    count: 3850,
                    percentage: 44.0,
                    agents: [
                        { name: "ChatGPT", count: 1540, percentage: 40.0, category: "AI Access Agents" },
                        { name: "Claude", count: 1155, percentage: 30.0, category: "AI Access Agents" },
                        { name: "Perplexity", count: 770, percentage: 20.0, category: "AI Access Agents" },
                        { name: "Gemini", count: 385, percentage: 10.0, category: "AI Access Agents" }
                    ]
                },
                {
                    name: "Human Traffic",
                    count: 2625,
                    percentage: 30.0,
                    agents: [
                        { name: "Direct Visits", count: 1313, percentage: 50.0, category: "Human Traffic" },
                        { name: "Social Media", count: 788, percentage: 30.0, category: "Human Traffic" },
                        { name: "Email Links", count: 524, percentage: 20.0, category: "Human Traffic" }
                    ]
                },
                {
                    name: "AI Data Scrapers",
                    count: 1575,
                    percentage: 18.0,
                    agents: [
                        { name: "GPTBot", count: 630, percentage: 40.0, category: "AI Data Scrapers" },
                        { name: "Claude-Web", count: 473, percentage: 30.0, category: "AI Data Scrapers" },
                        { name: "Anthropic-AI", count: 315, percentage: 20.0, category: "AI Data Scrapers" },
                        { name: "OpenAI-Crawler", count: 157, percentage: 10.0, category: "AI Data Scrapers" }
                    ]
                },
                {
                    name: "Traditional Bots",
                    count: 700,
                    percentage: 8.0,
                    agents: [
                        { name: "Googlebot", count: 350, percentage: 50.0, category: "Traditional Bots" },
                        { name: "Bingbot", count: 140, percentage: 20.0, category: "Traditional Bots" },
                        { name: "Facebookexternalhit", count: 70, percentage: 10.0, category: "Traditional Bots" },
                        { name: "Other crawlers", count: 140, percentage: 20.0, category: "Traditional Bots" }
                    ]
                }
            ],
            total_ai_agents: 5425,
            human_percentage: 30.0,
            ai_percentage: 70.0
        }
    },
    content_geographic: {
        "bmeyer_bmeyer-llm-verified-bug-fixes-2025": {
            total_countries: 45,
            top_country: "United States",
            top_country_percentage: 30.0,
            international_traffic: 70.0,
            countries: [
                {
                    country: "United States",
                    country_code: "US",
                    count: 4625,
                    percentage: 30.0,
                    ai_percentage: 72.5,
                    human_percentage: 27.5,
                    coordinates: { lat: 39.8283, lng: -98.5795 }
                },
                {
                    country: "Germany",
                    country_code: "DE", 
                    count: 2311,
                    percentage: 15.0,
                    ai_percentage: 68.2,
                    human_percentage: 31.8,
                    coordinates: { lat: 51.1657, lng: 10.4515 }
                },
                {
                    country: "United Kingdom",
                    country_code: "GB",
                    count: 1850,
                    percentage: 12.0,
                    ai_percentage: 70.1,
                    human_percentage: 29.9,
                    coordinates: { lat: 55.3781, lng: -3.4360 }
                },
                {
                    country: "Canada",
                    country_code: "CA",
                    count: 1388,
                    percentage: 9.0,
                    ai_percentage: 74.3,
                    human_percentage: 25.7,
                    coordinates: { lat: 56.1304, lng: -106.3468 }
                },
                {
                    country: "Other",
                    country_code: "XX",
                    count: 5246,
                    percentage: 34.0,
                    ai_percentage: 66.5,
                    human_percentage: 33.5,
                    coordinates: { lat: 0, lng: 0 }
                }
            ],
            top_cities: [
                { city: "San Francisco", country: "US", visits: 892, ai_percentage: 75.2 },
                { city: "London", country: "GB", visits: 654, ai_percentage: 68.9 },
                { city: "Berlin", country: "DE", visits: 578, ai_percentage: 71.3 },
                { city: "Toronto", country: "CA", visits: 445, ai_percentage: 76.8 },
                { city: "Tokyo", country: "JP", visits: 423, ai_percentage: 82.1 }
            ]
        },
        _: {
            countries: [
                {
                    country: "United States",
                    country_code: "US",
                    count: 2625,
                    percentage: 30.0,
                    ai_percentage: 70.0,
                    human_percentage: 30.0,
                    coordinates: { lat: 39.8283, lng: -98.5795 }
                },
                {
                    country: "Germany",
                    country_code: "DE",
                    count: 1313,
                    percentage: 15.0,
                    ai_percentage: 65.0,
                    human_percentage: 35.0,
                    coordinates: { lat: 51.1657, lng: 10.4515 }
                },
                {
                    country: "United Kingdom",
                    country_code: "GB",
                    count: 1050,
                    percentage: 12.0,
                    ai_percentage: 68.0,
                    human_percentage: 32.0,
                    coordinates: { lat: 55.3781, lng: -3.4360 }
                },
                {
                    country: "Other",
                    country_code: "XX",
                    count: 3762,
                    percentage: 43.0,
                    ai_percentage: 67.0,
                    human_percentage: 33.0,
                    coordinates: { lat: 0, lng: 0 }
                }
            ],
            total_countries: 25,
            top_cities: [
                { city: "San Francisco", country: "US", visits: 525, ai_percentage: 72.0 },
                { city: "London", country: "GB", visits: 368, ai_percentage: 66.0 },
                { city: "Berlin", country: "DE", visits: 315, ai_percentage: 68.0 }
            ]
        }
    },
    content_llm_referrals: {
        "bmeyer_bmeyer-llm-verified-bug-fixes-2025": {
            total_llm_referrals: 6741,
            unique_llm_systems: 4,
            avg_referral_quality: 8.7,
            referral_growth: 18.5,
            top_llm_systems: [
                {
                    name: "ChatGPT",
                    description: "OpenAI's conversational AI system",
                    referrals: 2856,
                    percentage: 42.4
                },
                {
                    name: "Claude",
                    description: "Anthropic's AI assistant",
                    referrals: 1823,
                    percentage: 27.0
                },
                {
                    name: "Perplexity",
                    description: "AI-powered search engine",
                    referrals: 1346,
                    percentage: 20.0
                },
                {
                    name: "Gemini",
                    description: "Google's AI assistant",
                    referrals: 716,
                    percentage: 10.6
                }
            ],
            platforms: [
                {
                    name: "ChatGPT",
                    referrals: 2856,
                    traffic_generated: 2142,
                    percentage: 45.2,
                    conversion_rate: 75.0,
                    avg_engagement: 195
                },
                {
                    name: "Claude",
                    referrals: 1823,
                    traffic_generated: 1368,
                    percentage: 28.9,
                    conversion_rate: 75.1,
                    avg_engagement: 210
                },
                {
                    name: "Perplexity",
                    referrals: 1346,
                    traffic_generated: 1012,
                    percentage: 21.3,
                    conversion_rate: 75.2,
                    avg_engagement: 185
                },
                {
                    name: "Gemini",
                    referrals: 716,
                    traffic_generated: 537,
                    percentage: 11.3,
                    conversion_rate: 75.0,
                    avg_engagement: 175
                }
            ],
            citation_metrics: {
                total_citations: 6741,
                accuracy_rate: 87.5,
                attributed_traffic: 5059,
                avg_citation_depth: 2.1
            },
            quality_distribution: {
                high: 4521,  // 8-10 quality score
                medium: 1854, // 5-7 quality score
                low: 366     // 1-4 quality score
            },
            trends: {
                dates: ["2024-01-01", "2024-01-02", "2024-01-03", "2024-01-04", "2024-01-05", "2024-01-06", "2024-01-07"],
                referrals: [910, 1010, 876, 1146, 1280, 977, 1077],
                unique_systems: [4, 4, 4, 4, 4, 4, 4]
            },
            recent_referrals: [
                {
                    id: "ref_001",
                    llm_system: "ChatGPT",
                    date: "2024-01-07",
                    context: "Discussion about automated bug fixing using large language models with formal verification",
                    quality_score: 9.2
                },
                {
                    id: "ref_002",
                    llm_system: "Claude",
                    date: "2024-01-06",
                    context: "Academic research on LLM applications in software engineering and verification",
                    quality_score: 8.8
                },
                {
                    id: "ref_003",
                    llm_system: "Perplexity",
                    date: "2024-01-06",
                    context: "Search query about automated program repair and LLM integration",
                    quality_score: 8.1
                }
            ]
        },
        _: {
            platforms: [
                {
                    name: "ChatGPT",
                    referrals: 1540,
                    traffic_generated: 1155,
                    percentage: 43.0,
                    conversion_rate: 75.0,
                    avg_engagement: 180
                },
                {
                    name: "Claude",
                    referrals: 1078,
                    traffic_generated: 808,
                    percentage: 30.1,
                    conversion_rate: 75.0,
                    avg_engagement: 195
                },
                {
                    name: "Perplexity",
                    referrals: 693,
                    traffic_generated: 520,
                    percentage: 19.3,
                    conversion_rate: 75.1,
                    avg_engagement: 165
                },
                {
                    name: "Gemini",
                    referrals: 270,
                    traffic_generated: 202,
                    percentage: 7.5,
                    conversion_rate: 74.8,
                    avg_engagement: 160
                }
            ],
            citation_metrics: {
                total_citations: 3581,
                accuracy_rate: 85.0,
                attributed_traffic: 2685,
                avg_citation_depth: 1.9
            },
            trends: [
                { date: "2024-01-01", "ChatGPT": 220, "Claude": 154, "Perplexity": 99, "Gemini": 39 },
                { date: "2024-01-02", "ChatGPT": 231, "Claude": 162, "Perplexity": 104, "Gemini": 41 },
                { date: "2024-01-03", "ChatGPT": 200, "Claude": 140, "Perplexity": 90, "Gemini": 35 },
                { date: "2024-01-04", "ChatGPT": 262, "Claude": 183, "Perplexity": 118, "Gemini": 46 },
                { date: "2024-01-05", "ChatGPT": 293, "Claude": 205, "Perplexity": 132, "Gemini": 51 },
                { date: "2024-01-06", "ChatGPT": 223, "Claude": 156, "Perplexity": 100, "Gemini": 39 },
                { date: "2024-01-07", "ChatGPT": 245, "Claude": 172, "Perplexity": 110, "Gemini": 43 }
            ]
        }
    }
}
;

